module.exports = __webpack_public_path__ + "img/pepe-full-art.d0eff926.jpg";